<div
  #dropdownContainer
  class="cm-typeahead-dropdown"
  [ngStyle]="getDropdownStyle()"
  role="listbox"
  aria-label="Autocomplete suggestions"
>
  <div class="suggestion-list">
    @for (
      suggestion of getVisibleSuggestions();
      track trackBySuggestion(i, suggestion);
      let i = $index
    ) {
      <div
        class="suggestion-item"
        [class.selected]="i === selectedIndex"
        [class.suggestion-keyword]="suggestion.type === 'keyword'"
        [class.suggestion-value]="suggestion.type !== 'keyword'"
        role="option"
        [attr.aria-selected]="i === selectedIndex"
        [attr.data-index]="i"
        (click)="onSuggestionClick(suggestion, i)"
        (mouseenter)="onSuggestionHover(i)"
      >
        <div class="suggestion-content">
          <div class="suggestion-label">{{ suggestion.label }}</div>
          @if (suggestion.info) {
            <div class="suggestion-info">
              {{ suggestion.info }}
            </div>
          }
        </div>
        @if (suggestion.type) {
          <div class="suggestion-type">
            {{ suggestion.type }}
          </div>
        }
      </div>
    }
  </div>

  <!-- Loading state (for future use) -->
  @if (suggestions.length === 0) {
    <div class="no-suggestions">No suggestions found</div>
  }
</div>
